import { useState } from "react";
import Card, { CardContent } from "../../../../Component/Common/Card";
import DateRangePicker from "../../../../Component/Common/DateRangePicker";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  Line
} from "recharts";

export default function EmailDashboard() {

  const categories = [
  "All",
  "Payments",
  "Onboarding",
  "Invoices",
  "Welcome",
  "OTP",
  "Warranty Provisioned",
  "Warranty Activated",
  "Claim Raised"
];

const categoryBadge = (category) => {
  switch (category) {
    case "Payments":
      return "bg-green-100 text-green-700";
    case "Onboarding":
      return "bg-blue-100 text-blue-700";
    case "Invoices":
      return "bg-purple-100 text-purple-700";
    case "Welcome":
      return "bg-pink-100 text-pink-700";
    case "OTP":
      return "bg-yellow-100 text-yellow-700";
    case "Warranty Provisioned":
      return "bg-indigo-100 text-indigo-700";
    case "Warranty Activated":
      return "bg-cyan-100 text-cyan-700";
    case "Claim Raised":
      return "bg-red-100 text-red-700";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

const statusBadge = (status) => {
  switch (status) {
    case "Sent":
      return "bg-blue-100 text-blue-700";
    case "Read":
      return "bg-green-100 text-green-700";
    case "Fail":
      return "bg-red-100 text-red-700";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

  const [activeCategory, setActiveCategory] = useState("Payments");
  const [search, setSearch] = useState("");
  const [dateType, setDateType] = useState("today");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const emailData = [
    { code:"RTL121", name: "Rahul", email: "rahul@gmail.com", category: "Payments", status: "Sent", date: "2026-03-12" },
    { code:"RTL122", name: "Amit", email: "amit@gmail.com", category: "Payments", status: "Read", date: "2026-03-11" },
    { code:"RTL123", name: "Pooja", email: "pooja@gmail.com", category: "Payments", status: "Fail", date: "2026-03-10" },

    { code:"RTL124", name: "Rohit", email: "rohit@gmail.com", category: "Onboarding", status: "Sent", date: "2026-03-12" },
    { code:"RTL125", name: "Meena", email: "meena@gmail.com", category: "Onboarding", status: "Read", date: "2026-03-11" },
    { code:"RTL126", name: "Karan", email: "karan@gmail.com", category: "Onboarding", status: "Fail", date: "2026-03-09" },

    { code:"RTL127", name: "Neha", email: "neha@gmail.com", category: "Invoices", status: "Sent", date: "2026-03-11" },
    { code:"RTL128", name: "Arjun", email: "arjun@gmail.com", category: "Invoices", status: "Read", date: "2026-03-10" },
    { code:"RTL129", name: "Riya", email: "riya@gmail.com", category: "Invoices", status: "Fail", date: "2026-03-08" }
  ];

  const filtered = emailData.filter((e) => {
  const categoryMatch =
    activeCategory === "All" || e.category === activeCategory;

    const searchMatch =
      e.name.toLowerCase().includes(search.toLowerCase()) ||
      e.email.toLowerCase().includes(search.toLowerCase());

    return categoryMatch && searchMatch;
  });

  const total = filtered.length;
  const sent = filtered.filter((d) => d.status === "Sent").length;
  const Read = filtered.filter((d) => d.status === "Read").length;
  const fail = filtered.filter((d) => d.status === "Fail").length;

  const pieData = [
    { name: "Sent", value: sent },
    { name: "Read", value: Read },
    { name: "Failed", value: fail }
  ];

  const pieColors = ["#6366F1", "#10B981", "#EF4444"];

  const activityData = Object.values(
  filtered.reduce((acc, item) => {
    const date = item.date;

    if (!acc[date]) {
      acc[date] = { date, value: 0 };
    }

    acc[date].value += 1;

    return acc;
  }, {})
);

  const deviceData = [
    { device: "Smartphone", opened: 50, clicks: 40 },
    { device: "Desktop", opened: 90, clicks: 95 },
    { device: "Tablet", opened: 30, clicks: 20 },
    { device: "Smartwatch", opened: 60, clicks: 70 },
    { device: "Other", opened: 40, clicks: 30 }
  ];

  const categoryPieData = categories
  .filter((c) => c !== "All")
  .map((cat) => ({
    name: cat,
    value: emailData.filter((e) => e.category === cat).length
  }));


const statusBarData = Object.values(
  filtered.reduce((acc, item) => {
    const date = new Date(item.date);

    const day = date.toLocaleDateString("en-US", {
      weekday: "short"
    });

    if (!acc[day]) {
      acc[day] = {
        day,
        Sent: 0,
        Read: 0,
        Failed: 0
      };
    }

    if (item.status === "Sent") acc[day].Sent += 1;
    if (item.status === "Read") acc[day].Read += 1;
    if (item.status === "Fail") acc[day].Failed += 1;

    return acc;
  }, {})
);

  return (
    <div className="bg-slate-50 min-h-screen p-6">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-slate-800">
          Email Analytics
        </h2>

        <div className="flex gap-3">
            <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={dateType}
            onChange={(e) => setDateType(e.target.value)}
            >
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="currentWeek">Current Week</option>
            <option value="lastWeek">Last Week</option>
            <option value="currentMonth">Current Month</option>
            <option value="lastMonth">Last Month</option>
            <option value="custom">Custom</option>
            </select>

         {dateType === "custom" && (
                    <DateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(start, end) => {
                        setStartDate(start);
                        setEndDate(end);
                      }}
                    />
                  )}
            </div>
      </div>

      {/* CATEGORY TABS */}
      <div className="flex gap-2 mb-4 overflow-x-auto">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap
            ${activeCategory === cat
              ? "bg-indigo-600 text-white"
              : "bg-white border"}
            `}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* KPI CARDS */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">

        <Card>
          <CardContent className="p-5">
            <p className="text-xs text-gray-500">Emails Sent</p>
            <p className="text-2xl font-bold">{total}</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-5">
            <p className="text-xs text-gray-500">Open Rate</p>
            <p className="text-2xl font-bold">86.84%</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-5">
            <p className="text-xs text-gray-500">Read Rate</p>
            <p className="text-2xl font-bold">2.63%</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-5">
            <p className="text-xs text-gray-500">Unsubscribe</p>
            <p className="text-2xl font-bold">3.03%</p>
          </CardContent>
        </Card>

      </div>

      {/* ANALYTICS CHARTS */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 my-6">

        {/* CATEGORY PIE CHART */}

        <Card>
        <CardContent className="p-4">
        <h3 className="text-sm font-semibold mb-4">
        Emails By Category
        </h3>

        <ResponsiveContainer width="100%" height={260}>
        <PieChart>

        <Pie
        data={categoryPieData}
        dataKey="value"
        nameKey="name"
        outerRadius={90}
        label
        >

        {categoryPieData.map((entry, index) => (
        <Cell
        key={index}
        fill={[
        "#22C55E",
        "#3B82F6",
        "#8B5CF6",
        "#EC4899",
        "#EAB308",
        "#6366F1",
        "#06B6D4",
        "#EF4444"
        ][index % 8]}
        />
        ))}

        </Pie>

        <Legend />
        <Tooltip />

        </PieChart>
        </ResponsiveContainer>

        </CardContent>
        </Card>


        {/* STATUS BAR CHART */}

        <Card>
            <CardContent className="p-4">

            <h3 className="text-sm font-semibold mb-4">
            Email Status Overview (Week)
            </h3>

            <ResponsiveContainer width="100%" height={260}>
            <BarChart data={statusBarData}>

            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />

            <Legend />

            <Bar dataKey="Sent" fill="#6366F1" radius={[4,4,0,0]} />
            <Bar dataKey="Read" fill="#10B981" radius={[4,4,0,0]} />
            <Bar dataKey="Failed" fill="#EF4444" radius={[4,4,0,0]} />

            </BarChart>
            </ResponsiveContainer>

            </CardContent>
            </Card>

        </div>

      

      {/* SEARCH */}
      <div className="mb-4">
        <input
          placeholder="Search name or email..."
          className="border px-3 py-2 rounded-lg text-sm w-64"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full">

          <thead className="bg-slate-100 text-sm">
            <tr>
              <th className="p-3 text-left">Code</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Category</th>
              <th className="p-3 text-left">Date</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((e, i) => (
              <tr key={i} className="border-b hover:bg-slate-50">
                <td className="p-3">{e.code}</td>
                <td className="p-3">{e.name}</td>
                <td className="p-3">{e.email}</td>
                <td className="p-3">
                    <span
                        className={`px-2 py-1 rounded text-xs font-medium ${categoryBadge(
                        e.category
                        )}`}
                    >
                        {e.category}
                    </span>
                    </td>
                <td className="p-3">{e.date}</td>
                <td className="p-3">
                    <span
                        className={`px-2 py-1 rounded text-xs font-medium ${statusBadge(
                        e.status
                        )}`}
                    >
                        {e.status}
                    </span>
                    </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

    </div>
  );
}

// import { useState } from "react";
// import { Mail, Send, CheckCheck, AlertTriangle } from "lucide-react";
// import Card, { CardContent } from "../../../../Component/Common/Card";
// import DateRangePicker from "../../../../Component/Common/DateRangePicker";
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip
// } from "recharts";

// export default function EmailDashboard() {

//   const categories = [
//     "Payments",
//     "Onboarding",
//     "Invoices",
//     "Welcome",
//     "OTP",
//     "Warranty Provisioned",
//     "Warranty Activated",
//     "Claim Raised"
//   ];

//   const [activeCategory, setActiveCategory] = useState("Payments");
//   const [search, setSearch] = useState("");
//   const [dateType, setDateType] = useState("today");
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const emailData = [
//   { name: "Rahul", email: "rahul@gmail.com", category: "Payments", status: "Sent", date: "2026-03-12" },
//   { name: "Amit", email: "amit@gmail.com", category: "Payments", status: "Read", date: "2026-03-11" },
//   { name: "Pooja", email: "pooja@gmail.com", category: "Payments", status: "Fail", date: "2026-03-10" },

//   { name: "Rohit", email: "rohit@gmail.com", category: "Onboarding", status: "Sent", date: "2026-03-12" },
//   { name: "Meena", email: "meena@gmail.com", category: "Onboarding", status: "Read", date: "2026-03-11" },
//   { name: "Karan", email: "karan@gmail.com", category: "Onboarding", status: "Fail", date: "2026-03-09" },

//   { name: "Neha", email: "neha@gmail.com", category: "Invoices", status: "Sent", date: "2026-03-11" },
//   { name: "Arjun", email: "arjun@gmail.com", category: "Invoices", status: "Read", date: "2026-03-10" },
//   { name: "Riya", email: "riya@gmail.com", category: "Invoices", status: "Fail", date: "2026-03-08" },

//   { name: "Ankit", email: "ankit@gmail.com", category: "Welcome", status: "Sent", date: "2026-03-12" },
//   { name: "Simran", email: "simran@gmail.com", category: "Welcome", status: "Read", date: "2026-03-11" },
//   { name: "Vikas", email: "vikas@gmail.com", category: "Welcome", status: "Fail", date: "2026-03-07" },

//   { name: "Amit", email: "amit2@gmail.com", category: "OTP", status: "Sent", date: "2026-03-12" },
//   { name: "Priya", email: "priya@gmail.com", category: "OTP", status: "Read", date: "2026-03-11" },
//   { name: "Nitin", email: "nitin@gmail.com", category: "OTP", status: "Fail", date: "2026-03-10" },

//   { name: "Sneha", email: "sneha@gmail.com", category: "Warranty Provisioned", status: "Sent", date: "2026-03-12" },
//   { name: "Deepak", email: "deepak@gmail.com", category: "Warranty Provisioned", status: "Read", date: "2026-03-10" },
//   { name: "Mohit", email: "mohit@gmail.com", category: "Warranty Provisioned", status: "Fail", date: "2026-03-08" },

//   { name: "Ramesh", email: "ramesh@gmail.com", category: "Warranty Activated", status: "Sent", date: "2026-03-11" },
//   { name: "Suresh", email: "suresh@gmail.com", category: "Warranty Activated", status: "Read", date: "2026-03-10" },
//   { name: "Geeta", email: "geeta@gmail.com", category: "Warranty Activated", status: "Fail", date: "2026-03-07" },

//   { name: "Kavita", email: "kavita@gmail.com", category: "Claim Raised", status: "Sent", date: "2026-03-12" },
//   { name: "Rajat", email: "rajat@gmail.com", category: "Claim Raised", status: "Read", date: "2026-03-11" },
//   { name: "Alok", email: "alok@gmail.com", category: "Claim Raised", status: "Fail", date: "2026-03-09" }
// ];

//   const filtered = emailData.filter((e) => {
//     const categoryMatch = e.category === activeCategory;

//     const searchMatch =
//       e.name.toLowerCase().includes(search.toLowerCase()) ||
//       e.email.toLowerCase().includes(search.toLowerCase());

//     return categoryMatch && searchMatch;
//   });

//   const total = filtered.length;
//   const sent = filtered.filter((d) => d.status === "Sent").length;
//   const Read = filtered.filter((d) => d.status === "Read").length;
//   const fail = filtered.filter((d) => d.status === "Fail").length;

//   const pieData = [
//   { name: "Sent", value: sent },
//   { name: "Read", value: Read },
//   { name: "Failed", value: fail }
// ];

// const pieColors = ["#3B82F6", "#10B981", "#EF4444"];


// const categoryChartData = categories.map((cat) => ({
//   name: cat,
//   value: emailData.filter((e) => e.category === cat).length
// }));

//   return (
//     <div className="min-h-screen bg-slate-50 p-4">

//       {/* CATEGORY TABS */}
//       <div className="flex gap-2 mb-6 overflow-x-auto">

//         {categories.map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setActiveCategory(cat)}
//             className={`px-4 py-2 rounded-xl text-sm font-semibold whitespace-nowrap
//             ${
//               activeCategory === cat
//                 ? "bg-blue-600 text-white"
//                 : "bg-white border text-gray-600"
//             }`}
//           >
//             {cat}
//           </button>
//         ))}

//       </div>

//       {/* KPI CARDS */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">

//         <Card>
//           <CardContent className="p-4 flex justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Total Emails</p>
//               <p className="text-xl font-bold">{total}</p>
//             </div>
//             <Mail className="text-blue-600" />
//           </CardContent>
//         </Card>

//         <Card>
//           <CardContent className="p-4 flex justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Sent</p>
//               <p className="text-xl font-bold">{sent}</p>
//             </div>
//             <Send className="text-blue-500" />
//           </CardContent>
//         </Card>

//         <Card>
//           <CardContent className="p-4 flex justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Read</p>
//               <p className="text-xl font-bold">{Read}</p>
//             </div>
//             <CheckCheck className="text-green-600" />
//           </CardContent>
//         </Card>

//         <Card>
//           <CardContent className="p-4 flex justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Failed</p>
//               <p className="text-xl font-bold">{fail}</p>
//             </div>
//             <AlertTriangle className="text-red-600" />
//           </CardContent>
//         </Card>

//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">

//   {/* STATUS PIE CHART */}
//   <Card>
//     <CardContent className="p-4">
//       <h3 className="text-sm font-semibold mb-4">
//         Email Status Distribution
//       </h3>

//       <ResponsiveContainer width="100%" height={260}>
//         <PieChart>
//           <Pie
//             data={pieData}
//             dataKey="value"
//             nameKey="name"
//             outerRadius={90}
//             label
//           >
//             {pieData.map((entry, index) => (
//               <Cell key={index} fill={pieColors[index]} />
//             ))}
//           </Pie>

//           <Legend />
//           <Tooltip />
//         </PieChart>
//       </ResponsiveContainer>
//     </CardContent>
//   </Card>


//   {/* CATEGORY BAR CHART */}
//   <Card>
//     <CardContent className="p-4">
//       <h3 className="text-sm font-semibold mb-4">
//         Emails by Category
//       </h3>

//       <ResponsiveContainer width="100%" height={260}>
//         <BarChart data={categoryChartData}>
//           <XAxis dataKey="name" hide />
//           <YAxis />
//           <Tooltip />

//           <Bar
//             dataKey="value"
//             fill="#3B82F6"
//             radius={[6, 6, 0, 0]}
//           />
//         </BarChart>
//       </ResponsiveContainer>
//     </CardContent>
//   </Card>

// </div>

//       {/* FILTERS */}
//       <div className="flex gap-3 mb-6">

//         <input
//           placeholder="Search name or email..."
//           className="border px-3 py-2 rounded-xl text-sm w-64"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         <select
//           className="border px-3 py-2 rounded-xl text-sm"
//           value={dateType}
//           onChange={(e) => setDateType(e.target.value)}
//         >
//           <option value="today">Today</option>
//           <option value="yesterday">Yesterday</option>
//           <option value="currentWeek">Current Week</option>
//           <option value="lastWeek">Last Week</option>
//           <option value="currentMonth">Current Month</option>
//           <option value="lastMonth">Last Month</option>
//           <option value="custom">Custom</option>
//         </select>

//         {dateType === "custom" && (
//           <DateRangePicker
//             startDate={startDate}
//             endDate={endDate}
//             onChange={(start, end) => {
//               setStartDate(start);
//               setEndDate(end);
//             }}
//           />
//         )}

//       </div>

//       {/* EMAIL LOG TABLE */}
//       <div className="bg-white rounded-2xl shadow overflow-hidden">

//         <table className="w-full">

//           <thead className="bg-blue-600 text-white text-sm">
//             <tr>
//               <th className="p-4 text-left">Name</th>
//               <th className="p-4 text-left">Email</th>
//               <th className="p-4 text-left">Category</th>
//               <th className="p-4 text-left">Date</th>
//               <th className="p-4 text-left">Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.map((e, i) => (
//               <tr key={i} className="border-b hover:bg-gray-50">

//                 <td className="p-3">{e.name}</td>
//                 <td className="p-3">{e.email}</td>
//                 <td className="p-3">{e.category}</td>
//                 <td className="p-3">{e.date}</td>

//                 <td className="p-3 font-semibold">
//                   {e.status}
//                 </td>

//               </tr>
//             ))}
//           </tbody>

//         </table>

//       </div>

//     </div>
//   );
// }